import { customerEquipment } from "constants/customer";

const initialState = {
    customerEquipment: {}
}

const customerEquipmentList = (state = initialState, action) => {
    switch (action.type) {
        case customerEquipment:
            return { ...state, customerEquipment: action.payload};
        
        default:
            return state;
    }
};

export default customerEquipmentList;


